import deepEqual from 'fast-deep-equal';
import {
    useCallback, useEffect, useRef, useState
} from 'react';


/**
 * Takes the given TParams and adds a pageNumber to it. When any of the given params change, the pageNumber is updated
 * to the first page.
 *
 * @param params - The params to add pageNumber to
 * @return A pair of the augmented params and a function to set the page number
 */
export function usePaginatedQueryParams<TParams>(params: TParams): [
    TParams & { pageNumber: number },
    (pageNumber: number) => void
] {
    const lastParamsRef = useRef(params);
    const [ finalParams, setFinalParams ] = useState({
        pageNumber: 1,
        ...params
    });

    useEffect(() => {
        if (!deepEqual(params, lastParamsRef.current)) {
            setFinalParams({
                pageNumber: 1,
                ...params
            });
        }

        lastParamsRef.current = params;
    }, [ params ]);

    const setPageNumber = useCallback((pageNumber: number) => {
        setFinalParams({
            ...lastParamsRef.current,
            pageNumber
        });
    }, []);

    return [ finalParams, setPageNumber ];
}
